import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { User } from 'src/app/model';
import { ReportProvider } from 'src/app/providers';
import { UserService, ToasterService } from 'src/app/services';

@Component({
  selector: 'app-share-report-modal',
  templateUrl: './share-report-modal.component.html',
  styleUrls: ['./share-report-modal.component.scss']
})
export class ShareReportModalComponent implements OnInit {

  subject: Subject<boolean>;
  companyName: string = '';
  reportId: string = '';
  reportVersionId: string = '';
  sharedWithOrg: boolean = false;
  createdBy: string = '';

  selectedUsers: Array<User> = [];
  email: string = '';

  USER_NAME_MODEL: string = '';
  userList: Array<User> = [];
  userAutoOpen: boolean = false;
  userError: boolean = false;
  searchingUser: boolean = false;
  showLoading: boolean = false;

  constructor(public showShareBsModalRef: BsModalRef,
    public userService: UserService,
    private reportProvider: ReportProvider,
    private toastr: ToasterService) { }

  ngOnInit(): void {
    this.getSharedUserList();
  }

  /**
   * @description get user list who has access of that report
   */
  getSharedUserList() {
    this.showLoading = true;
    this.reportProvider.getUsersHasBeenShared(this.reportId).subscribe(res => {
      if (res.success) {
        this.selectedUsers = User.parseArray(res.result);
      }
      this.showLoading = false;
    }, err => {
      this.showLoading = false;
      // Error Handling
    });
  }

  /**
   * @description share report to email
   */
  callSharingApi() {
    this.reportProvider.shareReport(this.reportId, this.email).subscribe(res => {
      if (res.success) {
        this.email = '';
        // this.selectedUsers.push(res.result);
      } else {
        this.email = '';
        if (res.error.code === 404) {
          this.toastr.success('Invitation sent!');
        } else {
          this.toastr.error(res.error.txt);          
        }
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description remove user from sharing 
   */
  removeUser(index: number, userId: string) {
    this.selectedUsers.splice(index, 1);
    this.removeSharing(userId);
  }

  /**
   * @description for get initials of user
   */
  getInitials(user: User) {
    let initial = '';
    if (user.NAME_FIRST) {
      initial = user.NAME_FIRST.charAt(0).toUpperCase();
    }
    if (user.NAME_LAST) {
      initial += user.NAME_LAST.charAt(0).toUpperCase();
    }
    return initial;
  }

  /**
   * @description remove sharing API call
   */
  removeSharing(userId: string) {
    this.reportProvider.removeShareReport(this.reportId, userId).subscribe(res => {
      if (res.success) {
      } 
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description share report to Org
   */
  shareAllOrgUser(option: boolean) {
    this.reportProvider.sharedWithAllOrgUsers(this.reportId, option).subscribe(res => {
      if (res.success) {
      } 
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description confirm click
   */
   confirm(): void {
    this.showShareBsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }

  
  /**
   * @description for auto complete user
   */
   autocompleteUsers(value: string): void {
    // Close AutoComplete
    this.userAutoOpen = false;
    this.userError = false;
    // Clear Current User Object
    if (value) {
      if (value.length > 0) {
        this.searchingUser = true;
        this.reportProvider.getOrgUserListOfOrg(1, 10, value).subscribe(res => {
          if (res.success) {
            let newUserList = res.result.items;
            if (this.selectedUsers.length && res.result.items?.length) {
              newUserList = newUserList.filter(x => !this.selectedUsers.filter(y => y.ID === x.ID || x.ID === this.userService.getUserId()).length);
            }
            setTimeout(() => {
              this.userList = newUserList;
              if (this.userList.length) {
                this.userAutoOpen = true;
              } else {
                this.userError = true;
              }
            }, 5);
          }
          else {
            this.userError = true;
          }
          this.searchingUser = false;
        }, err => {
          this.searchingUser = false;
          // Error Handling
        });
      } else {
        this.userList = [];
      }
    }
  }

  /**
   * @description on focus lost from user
   */
   userFocusLost(): void {
    setTimeout(() => {
      this.userAutoOpen = false;
    }, 150);
  }

  /**
   * @description on selection
   */
  selectGenerator(user: User) {
    this.selectedUsers.push(user);
    this.USER_NAME_MODEL = '';
    this.email = user.EMAIL;
    this.callSharingApi();

    setTimeout(() => {
      const selectedIndex = this.userList.findIndex(el => el.ID === user.ID);
      if (selectedIndex != 1) {
        this.userList.splice(selectedIndex, 1);
      }
    }, 5);
  }


}
